import { Routes, RouterModule, Router, RouteConfigLoadEnd } from '@angular/router';
import { AuthGuardService } from './authentication/guards/auth-guard.service';
import { DrawingLandingPageComponent } from './drawing-landing-page/drawing-landing-page.component';
import { WinnerLandingPageComponent } from './winner-landing-page/winner-landing-page.component';

import { FullComponent } from "./layouts/full/full.component";
import { NgModule } from '@angular/core';
import { addDynamicPath } from './shared/dynamic-routing/dynamic-path';
import { DynamicPathGuard } from "./shared/dynamic-routing/dynamic-path.guard";
import { DynamicBoardsGuard } from "./shared/dynamic-routing/dynamic-boards.guard";
import { ErrorComponent } from './authentication/error/error.component';
import { CommunicationService } from './services/communication/communication.service';

/**
 * This is root routing module for the project which contains the initial routing
 */
const APP_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'landing-page',
    component: DrawingLandingPageComponent
  },
  {
    path: 'winners',
    component: WinnerLandingPageComponent
  },
  {
    path: 'app',
    component: FullComponent,
    canActivate: [AuthGuardService, DynamicBoardsGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'rewards',
        loadChildren: () => import('./rewards/rewards.module').then(m => m.RewardsModule)
      },
      {
        path: 'patient',
        loadChildren: () => import('./patients/patients.module').then(m => m.PatientsModule)
      },
      {
        path: 'report',
        loadChildren: () => import('./report/report.module').then(m => m.ReportModule)
      },
      {
        path: 'insights',
        loadChildren: () => import('./insights/insights.module').then(m => m.InsightsModule)
      },
      {
        path: 'social-determinants',
        loadChildren: () => import('./social-determinants/social-determinants.module').then(m => m.SocialDeterminantsModule)
      }
    ]
  },
  { path: "404", component: ErrorComponent },
  {
    path: '**',
    canActivate: [DynamicPathGuard],
    component: ErrorComponent
  }
]
@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES, { useHash: false})],
  exports: [RouterModule]
})

export class AppRoutingModule {
  constructor(private router: Router,
    private communicationService: CommunicationService) {
     this.router.events.subscribe(async routerEvent => {
      if (routerEvent instanceof RouteConfigLoadEnd) {
        this.communicationService.getBoards.subscribe(data=>{
          addDynamicPath(this.router.config, 'dashboard', data)
        })     
      }      
    });
  }
}
